import script from "./FormNetworksComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormNetworksComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormNetworksComponent.vue?vue&type=style&index=0&id=54ab08c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54ab08c0"]])

export default __exports__